import React from 'react';
import {useTranslation} from 'react-i18next';

import type {ModalProps} from '@pexip/components';
import {
    Button,
    FontVariant,
    Text,
    TextHeading,
    ThemeProvider,
} from '@pexip/components';

import {Modal} from '../../components/Modal';

import {MAX_FAVORITES} from '../../constants';
import {TestId} from '../../../test/testIds';

export const FavoritesLimitReachedModal: React.FC<
    Pick<ModalProps, 'isOpen' | 'onClose'>
> = ({isOpen, onClose}) => {
    const {t} = useTranslation();

    return (
        <ThemeProvider colorScheme="light">
            <Modal
                isOpen={isOpen}
                onClose={onClose}
                data-testid={TestId.ModalFavoritesLimitReached}
                withCloseButton
                withAlternativeMaskColor
                sizeModifier="small"
                uniqueTitle={t(
                    'media.call-history.favorites-limit-reached.title',
                    'Favorites limit has been reached',
                )}
            >
                <TextHeading
                    className="mb-2"
                    htmlTag="h2"
                    fontVariant={FontVariant.H5}
                >
                    {t(
                        'media.call-history.favorites-limit-reached.title',
                        'Favorites limit has been reached',
                    )}
                </TextHeading>
                <Text>
                    {t(
                        'media.call-history.favorites-limit-reached.body',
                        "You've reached the maximum number of {{maxFavorites}} favorites. To add new favorites, please remove some existing ones first.",
                        {maxFavorites: MAX_FAVORITES},
                    )}
                </Text>
                <Button
                    className="mt-5"
                    data-testid={TestId.ButtonFavoritesLimitReachedModalOk}
                    modifier="fullWidth"
                    onClick={onClose}
                    variant="primary"
                >
                    {t('common.ok', 'Ok')}
                </Button>
            </Modal>
        </ThemeProvider>
    );
};

export type FavoritesLimitReachedModalProps = React.ComponentProps<
    typeof FavoritesLimitReachedModal
>;
